/* MV Sortiment assets/mv-sortiment.einklappen.js - Paket M-1 - 2026-10-07
 *
 * Mobil einklappbare Produktabschnitte (snippets/mv-einklappen.liquid). Inhaber 07.10.2026: "review alles und optimier";
 * Befund der Hauptsession: die Produktseite ist bei 375 px rund 27.000 px lang. Teil von assets/mv-sortiment.js
 * (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge mit den anderen Teilen. Kein Inline-Skript; nur
 * Delegation auf document (click in der Capture-Phase, shopify:section:load und :select, DOMContentLoaded), dazu
 * window hashchange und pageshow sowie die Medienabfrage MOBIL. Waechter window.__mvSortimentEinklappen, Wurzeln
 * [data-mv-einklappen]. Zustand nur im DOM, nichts wird gespeichert:
 *   data-mv-klapp-bereit  an der Wurzel: Kopf, Knopf und Inhalt gefunden; erst damit klappt die CSS unter 1000 px zu
 *   data-mv-klapp-offen   an der Wurzel: vom Nutzer, per Deep-Link oder im Theme-Editor geoeffnet
 *   hidden                am Kopf [data-mv-klapp-kopf]: ab 1000 px verborgen (ohne Skript immer)
 *   aria-expanded         am Knopf [data-mv-klapp-knopf]
 * Ab 1000 px gilt keine Regel der CSS: der Inhalt steht offen, der Kopf ist hidden - die Desktop-Ansicht bleibt wie
 * vor M-1. Ein Wechsel ueber die Grenze (Drehen, Fenstergroesse) zieht nur den Kopf nach; der Klappzustand bleibt.
 *
 * Deep-Links: Ziel ist das Element zur ID aus dem Anker (location.hash beim Laden und bei hashchange; Klick auf
 * einen Link derselben Seite, auch die Sprungleiste sections/mv-tabs.liquid mit data-mv-tab und deren Rueckfall
 * ueber den Sektionsschluessel wie in mv-sortiment.i2.js). Geoeffnet wird der Abschnitt, in dem das Ziel liegt,
 * sonst der einzige Abschnitt im Ziel (Sektionshuelle shopify-section-...); ein Ziel mit mehreren Abschnitten
 * (z. B. main fuer "Zum Inhalt springen") oeffnet nichts. Der Klick laeuft in der Capture-Phase, also vor dem
 * weichen Scrollen der Sprungleiste und vor dem nativen Ankersprung. Beim Laden mit Anker richtet das Skript das
 * Ziel nach dem Einklappen neu aus (die Abschnitte davor sind kuerzer geworden).
 *
 * Sichtbare Texte kommen aus dem Liquid; diese Datei bleibt reines ASCII. Unter Node (Tests) liefert die Datei
 * nur die reinen Funktionen ueber module.exports.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-07.1';
  // Gleiche Grenze wie die Medienabfrage in assets/mv-sortiment.einklappen.css (Impact: Desktop ab 1000 px)
  var MOBIL = 'screen and (max-width: 999.98px)';
  var WURZEL = '[data-mv-einklappen]';

  // ===========================================================================================
  // Reine Logik (ohne window und document; unter Node per module.exports pruefbar)
  // ===========================================================================================

  function text(x) {
    return x === null || x === undefined ? '' : String(x).trim();
  }

  // Pfad einer Link-Adresse ohne Suchteil: "/a?b" -> "/a", "https://shop.test/a" -> "/a", "" -> ""
  function pfadVon(adresse) {
    var ohneSuche = text(adresse).split('?')[0];
    var m = /^(?:[a-z][a-z0-9+.-]*:)?\/\/[^\/]*(\/.*)?$/i.exec(ohneSuche);
    return m ? (m[1] || '/') : ohneSuche;
  }

  // ID aus dem Anker einer Link-Adresse, wenn sie auf diese Seite zeigt (pfad = location.pathname), sonst ''.
  // "#x" und "/seite#x" (gleicher Pfad) -> "x"; anderer Pfad, kein oder leerer Anker -> ''; %-Kodierung aufgeloest
  function fragmentAus(href, pfad) {
    var h = text(href);
    var i = h.indexOf('#');
    if (i === -1) return '';
    var id = h.slice(i + 1);
    if (!id) return '';
    var vor = h.slice(0, i);
    if (vor !== '' && pfadVon(vor) !== text(pfad)) return '';
    try {
      return decodeURIComponent(id);
    } catch (e) {
      return id;
    }
  }

  // Sektionsschluessel aus der ID einer Sektionshuelle: "shopify-section-template--1__mv_faq" -> "mv_faq"
  function schluesselAus(id) {
    var t = text(id);
    var i = t.lastIndexOf('__');
    return i === -1 ? '' : t.slice(i + 2);
  }

  // Abschnitte, die ein Ziel oeffnet: der umgebende, sonst der einzige darin; mehrere darin -> keiner
  function zuOeffnen(ziel) {
    if (!ziel || typeof ziel.closest !== 'function') return [];
    var um = ziel.closest(WURZEL);
    if (um) return [um];
    var darin = typeof ziel.querySelectorAll === 'function' ? ziel.querySelectorAll(WURZEL) : [];
    return darin.length === 1 ? [darin[0]] : [];
  }

  // Sollzustand von Kopf und Knopf: der Kopf steht nur mobil, aria-expanded folgt dem Klappzustand
  function zustand(mobil, offen) {
    return { kopfVerborgen: !mobil, ariaExpanded: offen ? 'true' : 'false' };
  }

  var logik = {
    VERSION: VERSION,
    MOBIL: MOBIL,
    WURZEL: WURZEL,
    pfadVon: pfadVon,
    fragmentAus: fragmentAus,
    schluesselAus: schluesselAus,
    zuOeffnen: zuOeffnen,
    zustand: zustand
  };

  // Exportfenster nur unter Node (kein window): Tests laden die Datei als Skript mit module-Objekt
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  if (window.__mvSortimentEinklappen) return;
  var api = window.__mvSortimentEinklappen = { version: VERSION, logik: logik };
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (!MV.einklappen) MV.einklappen = api;

  var medien = typeof window.matchMedia === 'function' ? window.matchMedia(MOBIL) : null;

  // Ohne Medienabfrage gilt Desktop: Kopf verborgen, Inhalt offen (sicherer Rueckfall)
  function mobil() {
    return !!(medien && medien.matches);
  }

  function alsListe(x) {
    return Array.prototype.slice.call(x || []);
  }

  // direktes Kind mit dem Attribut (Kopf und Inhalt stehen direkt in der Wurzel)
  function kind(wurzel, attribut) {
    var kinder = wurzel.children || [];
    for (var i = 0; i < kinder.length; i++) {
      if (kinder[i].hasAttribute(attribut)) return kinder[i];
    }
    return null;
  }

  function anwenden(wurzel) {
    var kopf = kind(wurzel, 'data-mv-klapp-kopf');
    var inhalt = kind(wurzel, 'data-mv-klapp-inhalt');
    var knopf = kopf ? kopf.querySelector('[data-mv-klapp-knopf]') : null;
    // Unvollstaendiges Markup nie zuklappen: ohne Knopf liesse sich der Inhalt nicht mehr oeffnen
    if (!kopf || !inhalt || !knopf) {
      wurzel.removeAttribute('data-mv-klapp-bereit');
      if (kopf) kopf.hidden = true;
      return;
    }
    var soll = zustand(mobil(), wurzel.hasAttribute('data-mv-klapp-offen'));
    kopf.hidden = soll.kopfVerborgen;
    knopf.setAttribute('aria-expanded', soll.ariaExpanded);
    wurzel.setAttribute('data-mv-klapp-bereit', '');
  }

  function setze(wurzel, offen) {
    if (offen) wurzel.setAttribute('data-mv-klapp-offen', '');
    else wurzel.removeAttribute('data-mv-klapp-offen');
    anwenden(wurzel);
  }

  // Wurzeln im Bereich (auch der Bereich selbst, z. B. eine neu geladene Sektionshuelle)
  function wurzelnIn(bereich) {
    var liste = bereich && typeof bereich.querySelectorAll === 'function' ? alsListe(bereich.querySelectorAll(WURZEL)) : [];
    if (bereich && typeof bereich.matches === 'function' && bereich.matches(WURZEL)) liste.unshift(bereich);
    return liste;
  }

  function oeffneZiel(ziel) {
    var liste = zuOeffnen(ziel);
    liste.forEach(function (w) {
      setze(w, true);
    });
    return liste.length > 0;
  }

  function zielZuId(id) {
    return id ? document.getElementById(id) : null;
  }

  function zielAusAnker() {
    return zielZuId(fragmentAus(window.location.hash, window.location.pathname));
  }

  // Ziel eines Links derselben Seite; Sprungleiste: Rueckfall ueber den Sektionsschluessel (wie i2.js)
  function zielVonLink(link) {
    var ziel = zielZuId(fragmentAus(link.getAttribute('href'), window.location.pathname));
    if (!ziel && link.hasAttribute('data-mv-tab')) {
      var key = text(link.getAttribute('data-mv-tab')).replace(/[^\w-]/g, '');
      ziel = key ? document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]') : null;
    }
    return ziel;
  }

  // Capture-Phase: vor dem weichen Scrollen der Sprungleiste (i2.js, Bubble-Phase) und dem nativen Ankersprung
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var knopf = t.closest('[data-mv-klapp-knopf]');
    if (knopf) {
      var wurzel = knopf.closest(WURZEL);
      if (wurzel && wurzel.hasAttribute('data-mv-klapp-bereit')) setze(wurzel, !wurzel.hasAttribute('data-mv-klapp-offen'));
      return;
    }
    var link = t.closest('a[href]');
    if (link) oeffneZiel(zielVonLink(link));
  }, true);

  window.addEventListener('hashchange', function () {
    oeffneZiel(zielAusAnker());
  });

  function initBereich(bereich) {
    wurzelnIn(bereich).forEach(anwenden);
  }

  function initAlle() {
    initBereich(document);
    var ziel = zielAusAnker();
    if (!ziel) return;
    oeffneZiel(ziel);
    // Beim Laden mit Anker: Abschnitte davor sind zugeklappt, das Ziel steht weiter oben als beim Ankersprung
    if (mobil() && typeof ziel.scrollIntoView === 'function') ziel.scrollIntoView({ block: 'start' });
  }

  // Theme-Editor: bearbeitete oder gewaehlte Sektion offen zeigen
  document.addEventListener('shopify:section:load', function (e) {
    initBereich(e.target);
    wurzelnIn(e.target).forEach(function (w) {
      setze(w, true);
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    wurzelnIn(e.target).forEach(function (w) {
      setze(w, true);
    });
  });

  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) initBereich(document);
  });

  // Grenze 1000 px ueberschritten: Kopf nachziehen (der Inhalt folgt der CSS)
  if (medien) {
    var wechsel = function () {
      initBereich(document);
    };
    if (typeof medien.addEventListener === 'function') medien.addEventListener('change', wechsel);
    else if (typeof medien.addListener === 'function') medien.addListener(wechsel);
  }

  api.initialisieren = initAlle;
  api.oeffnen = oeffneZiel;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAlle);
  else initAlle();
})();
